import {
    UPDATE_PARTNER_SIGNUP_INPUT,
    UPDATE_PARTNER_SIGNUP_DATA,
    UPDATE_PARTNER_SIGNUP_LICENSE_INPUT,
    TOGGLE_PARTNER_LICENSE_PROVINCES,
    EMPTY_PARTNER_LOCAL_STORAGE,
    VALIDATE_PARTNER_SIGNUP_LICENSE_INPUT,
    VALIDATE_PARTNER_SIGNUP_INPUT,
    PARTNER_APPLICATION,
    PARTNER_APPLICATION_SUCCESS,
    PARTNER_APPLICATION_FAIL,
    PARTNER_VALIDATION_SUCCESS,
    PARTNER_VALIDATION_FAIL,
    PARTNER_APPLICATION_SERVER_FAIL
  } from '../actions/types';
  
export const INITIAL_STATE = {
    personalInput: {
      firstname: {
        value: '',
        label: 'Firstname',
        type: 'text',
        validation: {
            required: true,
            isName: true,
        },
        error: ''
      },
      lastname: {
        value: '',
        label: 'Lastname',
        type: 'text',
        validation: {
            required: true,
            isName: true,
        },
        error: ''
      },
      email: {
        value: '',
        label: 'Email',
        type: 'text',
        validation: {
            required: true,
            isEmail: true,
        },
        error: ''
      },
      address: {
        value: '',
        label: 'Address',
        type: 'text',
        validation: {
            required: true,
        },
        error: ''
      },
      address2: {
        value: '',
        label: 'Address2',
        type: 'text',
        validation: {
  
        },
        error: ''
      },
      province: {
        value: '',
        label: 'Province',
        type: 'select',
        validation: {
            required: true,
        },
        error: ''
      },
      city: {
        value: '',
        label: 'City',
        type: 'text',
        validation: {
            required: true,
        },
        error: ''
      },
      postalcode: {
        value: '',
        label: 'Postalcode',
        type: 'text',
        validation: {
            required: true,
            isPostal: true
        },
        error: ''
      },
      phone: {
        value: '',
        label: 'Phone',
        type: 'text',
        validation: {
            required: true,
            isPhone: true
        },
        error: ''
      },
      phoneext: {
        value: '',
        label: 'Phone Extension',
        type: 'number',
        validation: {

        },
        error: ''
      },
      
    },
  
    businessInput: {
      businessName: {
        value: '',
        label: 'Business Name',
        type: 'text',
        validation: {
            required: true,
            isCompanyName: true,
        },
        error: ''
      },
      businessPrincipalOfficer: {
        value: '',
        label: 'Principal Officer',
        type: 'text',
        validation: {
            required: true,
            isName: true,
        },
        error: ''
      },
      businessID: {
        value: '',
        label: 'Business Identification Number',
        type: 'text',
        validation: {
            required: true,
            isBIN: true
        },
        error: ''
      },
      businessPrincipalOfficerEmail: {
        value: '',
        label: 'Principal Officer Email',
        type: 'text',
        validation: {
            required: true,
            isEmail: true,
        },
        error: ''
      },
    },

    personalIDInput: {
      personalID: {
        value: '',
        label: 'Social Insurance Number',
        type: 'text',
        validation: {
            required: true,
            isSIN: true
        },
        error: ''
      }
    },

    licenseInput: {
      AB: {
        province: 'Alberta', 
        license: {value: '' , 
                  validation: {required: true, isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
      BC: {
        province: 'British Columbia',
        license: {value: '' , 
                  validation: {required: true,  isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
      SK: {
        province: 'Saskatchewan',
        license: {value: '' , 
                  validation: {required: true, isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
      MB: {
        province: 'Manitoba',
        license: {value: '' , 
                  validation: {required: true, isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
      ON: {
        province: 'Ontario',
        license: {value: '' , 
                  validation: {required: true, isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
      NS: {
        province: 'Nova Scotia',
        license: {value: '' , 
                  validation: {required: true, isLicense: true},
                  error: ''}, 
        expiry: {value: new Date(), 
                  validation: {required: true, isFutureDate: true},
                  error: ''}, 
        enabled: false},
    },

    bankingInput: {
      transitNumber: {
        value: '',
        label: 'Transit Number',
        type: 'text',
        validation: {
            required: true,
            isTransit: true
        },
        error: ''
      },
      institutionNumber: {
        value: '',
        label: 'Institution Number',
        type: 'text',
        validation: {
            required: true,
            isInstitution: true
        },
        error: ''
      },
      accountNumber: {
        value: '',
        label: 'Account Number',
        type: 'text',
        validation: {
            required: true,
            isAccount: true
        },
        error: ''
      },
    },

    agreementInput: {
      agentContract: {
        value: false,
        validation: {
            isChecked: true,
        },
        error: ''
      },
      salesCommissionSchedule: {
        value: false,
        validation: {
            isChecked: true,
        },
        error: ''
      },
      preAuthAgreement: {
        value: false,
        validation: {
            isChecked: true,
        },
        error: ''
      },

    },

    signupType: 0,
    obiManager: 1,
    error: '',
    loading: false,
    processSuccess: false,
    openModal: false,
    currentSignupStep: 0,
    version: '20.11.12:1'
  };
  
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case UPDATE_PARTNER_SIGNUP_DATA:
        return { ...state,
          [action.fieldName]: action.fieldValue
        };
        
      case UPDATE_PARTNER_SIGNUP_INPUT:
        return { ...state, [action.fieldGroup]: { ...state[action.fieldGroup], 
            [action.fieldName]: 
              {
                ...state[action.fieldGroup][action.fieldName],
                value: action.fieldValue,
              }
          }
        };

      case VALIDATE_PARTNER_SIGNUP_INPUT:
        return { ...state, [action.fieldGroup]: { ...state[action.fieldGroup], 
          [action.fieldName]: 
            {
              ...state[action.fieldGroup][action.fieldName],
              error: action.fieldError,
            }
          }
        };

      case VALIDATE_PARTNER_SIGNUP_LICENSE_INPUT:
        return { ...state, licenseInput: { ...state.licenseInput, 
            [action.fieldGroup]: 
              {
                ...state.licenseInput[action.fieldGroup],
                [action.fieldName]: 
                {
                  ...state.licenseInput[action.fieldGroup][action.fieldName],
                  error: action.fieldError,
                }
              }
          }
        };

      case UPDATE_PARTNER_SIGNUP_LICENSE_INPUT:
        return { ...state, licenseInput: { ...state.licenseInput, 
            [action.fieldGroup]: 
              {
                ...state.licenseInput[action.fieldGroup],
                [action.fieldName]: 
                {
                  ...state.licenseInput[action.fieldGroup][action.fieldName],
                  value: action.fieldValue,
                }
              }
          }
        };

      case EMPTY_PARTNER_LOCAL_STORAGE:
        return {...state, ...INITIAL_STATE}

      case PARTNER_VALIDATION_SUCCESS:
        return {...state, ...action.applicationData, currentSignupStep: 1 }

      case PARTNER_VALIDATION_FAIL:
        return {...state, ...action.applicationData, currentSignupStep: 0, error: 'Please correct the errors above.' }

      case PARTNER_APPLICATION:
        return {...state, loading: true }

      case PARTNER_APPLICATION_SUCCESS:
        return {...state, currentSignupStep: 2, loading: false, processSuccess: true}

      case PARTNER_APPLICATION_FAIL:
        return {...state, currentSignupStep: 0, loading: false, processSuccess: false }

      case PARTNER_APPLICATION_SERVER_FAIL:
        return {...state, error: action.error, loading: false, processSuccess: false}

      case TOGGLE_PARTNER_LICENSE_PROVINCES:
        return { ...state, licenseInput: { ...state.licenseInput, 
            [action.fieldGroup]: 
              {
                ...state.licenseInput[action.fieldGroup],
                license: {...state.licenseInput[action.fieldGroup].license, error: '', value: ''},
                expiry: {...state.licenseInput[action.fieldGroup].expiry, error: '', value: new Date().getFullYear()+'-01-01'},
                [action.fieldName]: !state.licenseInput[action.fieldGroup][action.fieldName],
              }
          }
        };
      default:
        return state;
    }
};

export default reducer;
  